import React from 'react';
import { ChevronLeft } from 'lucide-react';
interface PersonalityType {
  id: string;
  emoji: string;
  name: string;
  description: string;
}
interface Step2PersonalityProps {
  selectedPersonality: string;
  onSelect: (personality: string) => void;
  onNext: () => void;
  onBack: () => void;
}
export const Step2Personality: React.FC<Step2PersonalityProps> = ({
  selectedPersonality,
  onSelect,
  onNext,
  onBack
}) => {
  const personalities: PersonalityType[] = [{
    id: 'caregiver',
    emoji: '👩‍⚕️',
    name: 'Caregiver',
    description: 'Nurturing, supportive, and always there to take care of your needs.'
  }, {
    id: 'sage',
    emoji: '🧠',
    name: 'Sage',
    description: 'Wise, insightful, and loves to engage in deep, meaningful conversations.'
  }, {
    id: 'innocent',
    emoji: '😇',
    name: 'Innocent',
    description: 'Sweet, pure, and curious about exploring new experiences with you.'
  }, {
    id: 'jester',
    emoji: '😜',
    name: 'Jester',
    description: 'Playful, humorous, and always ready to lighten the mood.'
  }, {
    id: 'temptress',
    emoji: '💋',
    name: 'Temptress',
    description: 'Seductive, alluring, and skilled in the art of desire.'
  }, {
    id: 'dominant',
    emoji: '👑',
    name: 'Dominant',
    description: 'Assertive, commanding, and expects your complete submission.'
  }, {
    id: 'submissive',
    emoji: '🔗',
    name: 'Submissive',
    description: 'Obedient, eager to please, and follows your every command.'
  }, {
    id: 'lover',
    emoji: '❤️',
    name: 'Lover',
    description: 'Passionate, romantic, and focused on creating deep emotional connections.'
  }, {
    id: 'nympho',
    emoji: '🔥',
    name: 'Nympho',
    description: 'Insatiable, adventurous, and always craving physical intimacy.'
  }, {
    id: 'mean',
    emoji: '😈',
    name: 'Mean',
    description: 'Sassy, challenging, and enjoys pushing your buttons.'
  }, {
    id: 'confidant',
    emoji: '🤫',
    name: 'Confidant',
    description: 'Trustworthy, understanding, and the perfect keeper of your secrets.'
  }, {
    id: 'experimenter',
    emoji: '🧪',
    name: 'Experimenter',
    description: 'Curious, innovative, and eager to try new and exciting things.'
  }, {
    id: 'bitchy',
    emoji: '💅',
    name: 'Bitchy',
    description: 'Sharp-tongued, demanding, and not afraid to put you in your place.'
  }, {
    id: 'brat',
    emoji: '👸',
    name: 'Brat',
    description: 'Playfully defiant, teasing, and loves to be tamed.'
  }, {
    id: 'maternal',
    emoji: '🤱',
    name: 'Maternal',
    description: 'Warm, protective, and loves to care for you in every way.'
  }];
  const handleContinue = () => {
    if (selectedPersonality) {
      onNext();
    }
  };
  return <div className="space-y-6" data-id="element-22150">
      <div className="flex items-center mb-6" data-id="element-22151">
        <button onClick={onBack} className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800" data-id="element-22152">
          <ChevronLeft size={20} className="text-gray-500" data-id="element-22153" />
        </button>
        <div className="ml-4" data-id="element-22154">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-22155">
            Choose Personality
          </h2>
          <p className="text-gray-600 dark:text-gray-400" data-id="element-22156">
            Select a personality archetype for your Angel
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-22157">
        {personalities.map(personality => <div key={personality.id} onClick={() => onSelect(personality.id)} className={`p-4 rounded-xl border cursor-pointer transition-all ${selectedPersonality === personality.id ? 'border-pink-500 bg-pink-50 dark:bg-pink-900/20 shadow-md' : 'border-gray-200 dark:border-gray-700 hover:border-pink-300 dark:hover:border-pink-700 hover:shadow-sm'}`} data-id="element-22158">
            <div className="flex items-start" data-id="element-22159">
              <div className="text-2xl mr-3" data-id="element-22160">{personality.emoji}</div>
              <div data-id="element-22161">
                <h3 className="font-medium text-gray-900 dark:text-white" data-id="element-22162">
                  {personality.name}
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-400 mt-1" data-id="element-22163">
                  {personality.description}
                </p>
              </div>
            </div>
          </div>)}
      </div>
      <div className="pt-6" data-id="element-22164">
        <div className="text-xs text-gray-500 dark:text-gray-400 mb-2 flex items-center" data-id="element-22165">
          <span className="w-4 h-4 inline-flex items-center justify-center bg-gray-200 dark:bg-gray-700 rounded-full mr-2 text-xs" data-id="element-22166">
            ?
          </span>
          This defines your Angel's tone and emotional energy
        </div>
        <button onClick={handleContinue} disabled={!selectedPersonality} className={`w-full py-3 rounded-lg font-medium text-white ${!selectedPersonality ? 'bg-gray-400 cursor-not-allowed' : 'bg-gradient-to-r from-pink-500 to-purple-600 hover:shadow-lg hover:shadow-pink-500/30 transition-all'}`} data-id="element-22167">
          Next: Define Relationship Type
        </button>
      </div>
    </div>;
};